/* ==========================================================================
   BDS — Flag "Choose Printing Option" (draft build, Sep 2026)

   The flag configurator already splits "Choose Printing Option" into two
   controls, both built by the live storefront module:

       #bdsf-seg          segmented buttons for the print side  (data-p)
       .bdsf-opt[data-f]  the rows of the "Choose Fabric" picker

   This module only extends the segmented control so it lists the four
   printing methods we sell:

       1. Single-Sided - Mirror Back
       2. Double-Sided - Grey Liner
       3. Duplex - Same Design Both Sides
       4. Duplex Blockout - 2 Different Designs

   All four are always listed. Which are buildable depends on the flag shape
   and the size chosen, exactly as CFM restricts them; picking one that can't
   be made opens a short note explaining why, and offers the link when we do
   sell it on another listing.

   SAFETY
   - No product, variant or price data is touched.
   - The real Shopify option <select> is never read from, written to, hidden
     or re-ordered by this module.
   - The storefront module's own buttons are kept - same element, same
     data-p, same click handler - so selecting a printing side behaves
     exactly as it does today. Only their visible label changes.
   - Everything this module adds carries data-bds-m, so it can be told apart
     from the storefront module's own markup.
   - Anything unexpected -> bail out silently, leaving the page as it was.
   ========================================================================== */
;(function () {
  "use strict";
  if (window.__BDS_FLAGPRINT__) return;
  window.__BDS_FLAGPRINT__ = 1;

  var DASH = "–";

  var M = {
    SINGLE:          "Single-Sided " + DASH + " Mirror Back",
    DOUBLE:          "Double-Sided " + DASH + " Grey Liner",
    DUPLEX:          "Duplex " + DASH + " Same Design Both Sides",
    DUPLEX_BLOCKOUT: "Duplex Blockout " + DASH + " 2 Different Designs",
    TRIPLE:          "Triple-Sided Print"
  };
  var ORDER = ["SINGLE", "DOUBLE", "DUPLEX", "DUPLEX_BLOCKOUT", "TRIPLE"];

  var WHAT = {
    SINGLE: "One layer, printed on one face. The back shows the same artwork in mirror image.",
    DOUBLE: "Two printed layers sewn together with a grey blockout liner between them, so the artwork reads the right way round on both faces.",
    DUPLEX: "A single layer printed through, so the same design reads correctly on both faces — no liner, no extra weight.",
    DUPLEX_BLOCKOUT: "A single layer of blockout fabric printed on each face, so you can run two completely different designs back to back.",
    TRIPLE: "Printed across three panels."
  };

  /* ----------------------------------------------------------------------
     Where duplex printing is actually made (CFM, verified 15 Sep 2026).
       t      the listing on our store that sells it, or null
       sz     size tokens it is made in, or "*" for every size
       bo     false when the blockout fabric isn't made for this shape
       boNot  sizes that have no blockout
       x      true when t is the same shape as this page
       same   CFM makes it on this very product; we just don't stock it yet
     ---------------------------------------------------------------------- */
  var DUPLEX = {
    "concave-feather-flag-banner":            { t: "duplex-printing-blade-advertising-flag",           sz: ["6ft","8ft","9ft","11ft","13ft","15ft","16ft"], bo: true,  x: false, shape: "concave" },
    "angled-feather-flag-banner":             { t: "duplex-printing-blade-advertising-flag",           sz: ["6ft","8ft","9ft","11ft","13ft","15ft","16ft"], bo: true,  x: false, shape: "angled" },
    "straight-feather-flag-banner":           { t: "duplex-printing-blade-advertising-flag",           sz: ["6ft","8ft","9ft","11ft","13ft","15ft","16ft"], bo: true,  x: true,  shape: "straight" },
    "convex-feather-flag-banner":             { t: "duplex-printing-blade-advertising-flag",           sz: ["6ft","8ft","9ft","11ft","13ft","15ft","16ft"], bo: false, x: false, shape: "convex" },
    "teardrop-feather-flag-banner":           { t: "duplex-printing-teardrop-advertising-flag",        sz: ["7ft","9ft","11ft","13ft","15ft","16ft"],       bo: true,  x: true },
    "rectangle-flag":                         { t: "duplex-printing-rectangle-advertising-flag",       sz: ["7ft","10ft","14ft","17ft"],                    bo: true,  x: true },
    "rectangle-flag-with-uni-fit-pole":       { t: "duplex-printing-rectangle-flag-with-uni-fit-pole", sz: ["M-6ft","L-9ft","XL-12ft"],                     bo: true,  x: true },
    "shark-fin-flag-with-uni-fit-pole":       { t: "duplex-printing-shark-fin-flag-with-uni-fit-pole", sz: ["S-7.5ft","M-10ft","L-13ft","XL-16ft"],         bo: true,  x: true },
    "straight-feather-flag-with-uni-fit-pole":{ t: "duplex-printing-straight-flag-with-uni-fit-pole",  sz: ["S-7.5ft","M-10ft","L-13ft"],                   bo: true,  x: true },
    "teardrop-feather-flag-with-uni-fit-pole":{ t: "duplex-printing-teardrop-flag-with-uni-fit-pole",  sz: ["S-6.5ft","M-9ft","L-11.5ft","XL-14ft"],        bo: true,  x: true },
    "custom-garden-flags":                    { t: "duplex-printing-garden-flags",                     sz: ["12\"","13\""],                                 bo: true,  x: true },
    "custom-golf-flags":                      { t: "duplex-printing-golf-flags",                       sz: ["14.6\""],                                      bo: true,  x: true },

    /* CFM makes duplex on these same listings; we don't stock it yet. */
    "custom-printed-hand-flags":              { t: null, sz: ["4\"","6\"","8\"","12\"","16\"","24\""], bo: true,  boNot: ["16\""], x: false, same: true, shape: "hand flag" },
    "custom-car-antenna-flags":               { t: null, sz: "*", bo: false, x: false, same: true, shape: "car antenna flag" },
    "custom-car-window-flags":                { t: null, sz: "*", bo: false, x: false, same: true, shape: "car window flag" },
    "custom-desk-flags":                      { t: null, sz: "*", bo: false, x: false, same: true, shape: "desk flag" },
    "swooper-fabric-flag":                    { t: null, sz: "*", bo: true,  x: false, same: true, shape: "swooper" }
  };

  /* Duplex listings -> the listing that makes single / double sided. */
  var PLAIN = {
    "duplex-printing-blade-advertising-flag":           "straight-feather-flag-banner",
    "duplex-printing-teardrop-advertising-flag":        "teardrop-feather-flag-banner",
    "duplex-printing-rectangle-advertising-flag":       "rectangle-flag",
    "duplex-printing-rectangle-flag-with-uni-fit-pole": "rectangle-flag-with-uni-fit-pole",
    "duplex-printing-shark-fin-flag-with-uni-fit-pole": "shark-fin-flag-with-uni-fit-pole",
    "duplex-printing-straight-flag-with-uni-fit-pole":  "straight-feather-flag-with-uni-fit-pole",
    "duplex-printing-teardrop-flag-with-uni-fit-pole":  "teardrop-feather-flag-with-uni-fit-pole",
    "duplex-printing-garden-flags":                     "custom-garden-flags",
    "duplex-printing-golf-flags":                       "custom-golf-flags"
  };

  var TITLE = {
    "duplex-printing-blade-advertising-flag":           "Duplex Printing Blade Advertising Flag",
    "duplex-printing-teardrop-advertising-flag":        "Duplex Printing Teardrop Advertising Flag",
    "duplex-printing-rectangle-advertising-flag":       "Duplex Printing Rectangle Advertising Flag",
    "duplex-printing-rectangle-flag-with-uni-fit-pole": "Duplex Printing Rectangle Flag with Uni-Fit Pole",
    "duplex-printing-shark-fin-flag-with-uni-fit-pole": "Duplex Printing Shark Fin Flag with Uni-Fit Pole",
    "duplex-printing-straight-flag-with-uni-fit-pole":  "Duplex Printing Straight Flag with Uni-Fit Pole",
    "duplex-printing-teardrop-flag-with-uni-fit-pole":  "Duplex Printing Teardrop Flag with Uni-Fit Pole",
    "duplex-printing-garden-flags":                     "Duplex Printing Garden Flags",
    "duplex-printing-golf-flags":                       "Duplex Printing Golf Flags"
  };

  var SUFFIX = {
    elsewhere: "separate listing",
    quote:     "made to order",
    size:      "not at this size",
    shape:     "not in this shape",
    none:      "not on this flag"
  };

  /* ---------------------------------------------------------------- utils */
  function txt(s) { return String(s == null ? "" : s); }
  function esc(s) { return txt(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"); }

  function methodOfPrefix(p) {
    p = txt(p);
    if (/^triple/i.test(p)) return "TRIPLE";
    if (/^double\s+side/i.test(p)) return "DOUBLE";
    return "SINGLE";
  }
  function isBlockout(f) { return /blockout/i.test(txt(f)); }
  function isDuplexFabric(f) { return /duplex\s+printable/i.test(txt(f)); }

  function sizeToken(s) {
    s = txt(s).trim();
    var m = s.match(/^((?:XS|S|M|L|XL|XXL)-[0-9.]+\s*ft)/i); if (m) return m[1].replace(/\s+/g, "");
    m = s.match(/^([0-9.]+\s*ft)/i);                          if (m) return m[1].replace(/\s+/g, "");
    m = s.match(/^([0-9.]+\s*")/);                            if (m) return m[1].replace(/\s+/g, "");
    return s;
  }

  function handle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : "";
  }

  /* ------------------------------------------------------------- the popup */
  var POP = null;
  function popup(title, body, href, linkText, onLink) {
    try {
      if (!POP) {
        POP = document.createElement("div");
        POP.id = "bds-flagprint-pop";
        POP.setAttribute("data-bds-m", "popup");
        POP.style.cssText =
          "position:fixed;inset:0;z-index:2147483000;display:none;" +
          "background:rgba(17,17,17,.45);align-items:center;justify-content:center;padding:18px";
        POP.innerHTML =
          '<div role="dialog" aria-modal="true" aria-labelledby="bds-fp-t" ' +
          'style="background:#fff;max-width:520px;width:100%;border-radius:12px;' +
          'box-shadow:0 18px 50px rgba(0,0,0,.25);overflow:hidden;font-size:15px;line-height:1.5;color:#222">' +
            '<div style="background:#fff8e1;border-bottom:1px solid #f0dca0;padding:16px 20px;display:flex;gap:10px;align-items:flex-start">' +
              '<span aria-hidden="true" style="flex:0 0 auto;font-size:18px;line-height:1.3">&#9888;</span>' +
              '<strong id="bds-fp-t" style="font-size:16px;color:#5c4500"></strong>' +
            '</div>' +
            '<div data-bds-fp-body style="padding:16px 20px"></div>' +
            '<div style="padding:0 20px 18px;display:flex;gap:10px;flex-wrap:wrap;justify-content:flex-end">' +
              '<button type="button" data-bds-fp-act style="display:none;padding:10px 16px;border-radius:8px;border:0;background:#C8102E;color:#fff;cursor:pointer;font-weight:600"></button>' +
              '<a data-bds-fp-link href="#" style="display:none;padding:10px 16px;border-radius:8px;background:#C8102E;color:#fff;text-decoration:none;font-weight:600"></a>' +
              '<button type="button" data-bds-fp-close style="padding:10px 16px;border-radius:8px;border:1px solid #d5d5d5;background:#fff;cursor:pointer;font-weight:600">Close</button>' +
            '</div>' +
          '</div>';
        document.body.appendChild(POP);
        POP.addEventListener("click", function (e) {
          if (e.target === POP || e.target.hasAttribute("data-bds-fp-close")) hide();
        });
        document.addEventListener("keydown", function (e) {
          if (e.key === "Escape" && POP && POP.style.display === "flex") hide();
        });
      }
      POP.querySelector("#bds-fp-t").textContent = title;
      POP.querySelector("[data-bds-fp-body]").innerHTML = body;

      var a = POP.querySelector("[data-bds-fp-link]");
      if (href) { a.href = href; a.textContent = linkText; a.style.display = "inline-block"; }
      else { a.style.display = "none"; }

      var act = POP.querySelector("[data-bds-fp-act]");
      act.onclick = null;
      if (onLink) {
        act.textContent = linkText || "Show me";
        act.style.display = "inline-block";
        act.onclick = function () { hide(); try { onLink(); } catch (e) {} };
      } else {
        act.style.display = "none";
      }

      POP.style.display = "flex";
      var c = POP.querySelector("[data-bds-fp-close]"); if (c && c.focus) c.focus();
    } catch (e) {}
  }
  function hide() { if (POP) POP.style.display = "none"; }

  /* ------------------------------------------------------------ the module */
  var H = handle();
  var dup = DUPLEX[H] || null;
  var plain = PLAIN[H] || null;
  var isDuplexListing = !!plain;
  var busy = false;

  function seg() { return document.getElementById("bdsf-seg"); }
  function sizeSel() { return document.querySelector('select[data-variant-option="0"]'); }
  function fabricRows() { return [].slice.call(document.querySelectorAll(".bdsf-opt[data-f]")); }
  function currentFabric() {
    var on = document.querySelector(".bdsf-opt.on[data-f]");
    if (on) return on.getAttribute("data-f");
    var b = document.querySelector("#bdsf-btn .cname");
    return b ? txt(b.textContent).trim() : "";
  }

  function style() {
    if (document.getElementById("bds-flagprint-css")) return;
    var s = document.createElement("style");
    s.id = "bds-flagprint-css";
    s.textContent =
      "#bdsf-seg button[data-bds-m]{opacity:.62;border-style:dashed!important;cursor:pointer}" +
      "#bdsf-seg button[data-bds-m]:hover{opacity:.9}" +
      "#bdsf-seg button[data-bds-m] .bds-why{display:block;font-size:11px;font-weight:600;letter-spacing:.02em;opacity:.85;margin-top:2px}";
    document.head.appendChild(s);
  }

  /* which methods this page can actually build right now */
  function available() {
    var out = {};
    var sg = seg();
    if (sg) {
      [].forEach.call(sg.querySelectorAll("button[data-p]"), function (b) {
        if (b.hasAttribute("data-bds-m")) return;
        if (isDuplexListing) return;              /* handled below */
        out[methodOfPrefix(b.getAttribute("data-p"))] = true;
      });
    }
    if (isDuplexListing) {
      var fr = fabricRows();
      var anyPlain = false, anyBo = false;
      fr.forEach(function (r) {
        var f = r.getAttribute("data-f");
        if (isBlockout(f)) anyBo = true;
        else if (isDuplexFabric(f)) anyPlain = true;
      });
      if (anyPlain) out.DUPLEX = true;
      if (anyBo) out.DUPLEX_BLOCKOUT = true;
    }
    return out;
  }

  /* why a method can't be used here (null = it can) */
  function blocked(k, have) {
    if (have[k]) return null;

    if (k === "DUPLEX" || k === "DUPLEX_BLOCKOUT") {
      if (!dup) {
        return {
          tag: "none",
          why: "We don't make duplex printing on this flag.",
          body: "<p>" + esc(WHAT[k]) + "</p><p>Duplex printing needs a single-layer duplex fabric, and it isn't produced in this flag shape. " +
                "For this flag, choose <b>" + esc(M.SINGLE) + "</b> or <b>" + esc(M.DOUBLE) + "</b>.</p>"
        };
      }
      var ss = sizeSel();
      var sz = ss ? sizeToken(ss.value) : "";
      var boHere = dup.bo && !(dup.boNot || []).some(function (x) { return x.toLowerCase() === sz.toLowerCase(); });

      if (k === "DUPLEX_BLOCKOUT" && !boHere) {
        return {
          tag: dup.bo ? "size" : "shape",
          why: dup.bo ? "Duplex blockout isn't made at " + sz + "." : "Duplex blockout isn't made in this shape.",
          body: "<p>" + esc(WHAT.DUPLEX_BLOCKOUT) + "</p><p>The blockout fabric isn't produced " +
                (dup.bo ? "at " + esc(sz) : "in the " + esc(dup.shape || "this") + " shape") +
                ", so two different designs back to back aren't possible here. <b>" + esc(M.DUPLEX) +
                "</b> is available, and <b>" + esc(M.DOUBLE) + "</b> gives you two correct-reading faces of the same design.</p>"
        };
      }
      var fits = dup.sz === "*" || !sz || dup.sz.some(function (x) { return x.toLowerCase() === sz.toLowerCase(); });
      if (!fits) {
        return {
          tag: "size",
          why: sz + " isn't made in duplex printing.",
          body: "<p>" + esc(WHAT[k]) + "</p><p>Duplex printing is made in these lengths: <b>" + dup.sz.map(esc).join(", ") + "</b>. " +
                "Pick one of those, or stay with <b>" + esc(M.SINGLE) + "</b> or <b>" + esc(M.DOUBLE) + "</b> at " + esc(sz) + ".</p>",
          href: dup.x && dup.t ? "/products/" + dup.t : null,
          link: dup.x && dup.t ? "See the duplex version" : null
        };
      }
      if (!dup.x) {
        return {
          tag: "quote",
          why: "Duplex printing on this flag is made to order.",
          body: "<p>" + esc(WHAT[k]) + "</p><p>We do produce it " +
                (dup.same ? "on this " + esc(dup.shape || "flag") : "in the " + esc(dup.shape || "this") + " shape") +
                (sz ? " at " + esc(sz) : "") + ", but it isn't a stocked option on the site yet. " +
                "Use <b>Request Custom Size Quote</b> on this page and we'll price it for you.</p>" +
                (dup.t ? "<p style=\"opacity:.8\">The nearest listed duplex flag is the " + esc(TITLE[dup.t] || "duplex version") + ".</p>" : ""),
          href: dup.t ? "/products/" + dup.t : null,
          link: dup.t ? "See the listed duplex flag" : null
        };
      }
      return {
        tag: "elsewhere",
        why: "Duplex printing is its own listing.",
        body: "<p>" + esc(WHAT[k]) + "</p><p>It's built on a different fabric, so we sell it as a separate product with its own sizes, hardware options and pricing.</p>",
        href: "/products/" + dup.t,
        link: "Go to " + (TITLE[dup.t] || "the duplex version")
      };
    }

    if (k === "SINGLE" || k === "DOUBLE") {
      if (plain) {
        return {
          tag: "elsewhere",
          why: "This listing is duplex printing only.",
          body: "<p>" + esc(WHAT[k]) + "</p><p>This product is printed on single-layer duplex fabric. " +
                "Single-sided and double-sided printing are on the standard listing for this flag.</p>",
          href: "/products/" + plain,
          link: "Go to the standard version"
        };
      }
      return {
        tag: "none",
        why: (k === "DOUBLE" ? "Double-sided" : "Single-sided") + " printing isn't offered on this flag.",
        body: "<p>" + esc(WHAT[k]) + "</p><p>This flag is only made with the other printing option shown here.</p>"
      };
    }
    return { tag: "none", why: "Not available on this flag.", body: "<p>" + esc(WHAT[k] || "") + "</p>" };
  }

  /* pick a fabric row on a duplex listing (the storefront module owns the click) */
  function pickFabric(wantBlockout) {
    var row = fabricRows().filter(function (r) {
      return isBlockout(r.getAttribute("data-f")) === !!wantBlockout;
    })[0];
    if (!row) return false;
    var opener = document.getElementById("bdsf-btn");
    if (opener && !row.offsetParent) opener.click();
    row.click();
    if (row.scrollIntoView) row.scrollIntoView({ block: "nearest" });
    return true;
  }

  function ghost(k, b) {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.setAttribute("data-bds-m", k);
    btn.innerHTML = esc(M[k]) + '<span class="bds-why">' + esc(SUFFIX[b.tag] || "not available") + "</span>";
    btn.addEventListener("click", function (e) {
      e.preventDefault(); e.stopPropagation();
      var cur = blocked(k, available());          /* re-check against the size chosen now */
      if (!cur) { paint(); return; }
      popup(cur.why, cur.body, cur.href, cur.link);
    });
    return btn;
  }

  function paint() {
    var sg = seg();
    if (!sg || busy) return;
    busy = true;
    try {
      if (!window.__BDS_FP_READY) { try { window.__BDS_FP_READY = Math.round(performance.now()); window.__BDS_FP_MODE = "seg"; } catch (e) {} }
      style();
      var have = available();

      var boNow = isDuplexListing && isBlockout(currentFabric());

      /* relabel the storefront module's own buttons, keep everything else */
      [].forEach.call(sg.querySelectorAll("button[data-p]"), function (b) {
        if (b.hasAttribute("data-bds-m")) return;
        var k = isDuplexListing ? "DUPLEX" : methodOfPrefix(b.getAttribute("data-p"));
        b.setAttribute("data-bds-k", k);
        if (b.textContent !== M[k]) b.textContent = M[k];

        /* On a duplex listing there is only one print side, so the storefront
           module's own click handler returns early (pv === curPrint) and does
           nothing. Its button therefore stands for "same design both sides",
           and clicking it switches the fabric back off blockout. */
        if (isDuplexListing && !b.getAttribute("data-bds-bound")) {
          b.setAttribute("data-bds-bound", "1");
          b.addEventListener("click", function () {
            if (isBlockout(currentFabric())) { pickFabric(false); setTimeout(paint, 30); }
          }, true);
        }
        if (isDuplexListing) {
          if (boNow) b.classList.remove("on"); else b.classList.add("on");
        }
      });

      /* drop our previous ghosts, then rebuild for the size chosen now */
      [].forEach.call(sg.querySelectorAll("button[data-bds-m]"), function (b) { b.parentNode.removeChild(b); });

      ORDER.forEach(function (k) {
        if (k === "TRIPLE" && !have.TRIPLE) return;
        var real = sg.querySelector('button[data-bds-k="' + k + '"]');
        if (real) { sg.appendChild(real); return; }          /* keep, in order */

        if (isDuplexListing && (k === "DUPLEX" || k === "DUPLEX_BLOCKOUT") && have[k]) {
          /* the other duplex fabric: a real choice, made through the picker */
          var btn = document.createElement("button");
          btn.type = "button";
          btn.setAttribute("data-bds-m", k);
          btn.setAttribute("data-bds-live", "1");
          btn.textContent = M[k];
          btn.style.opacity = "1";
          btn.style.borderStyle = "";
          if (k === "DUPLEX_BLOCKOUT" && boNow) btn.className = "on";
          btn.addEventListener("click", function (e) {
            e.preventDefault(); e.stopPropagation();
            if (!pickFabric(k === "DUPLEX_BLOCKOUT")) {
              popup(M[k], "<p>" + esc(WHAT[k]) + "</p><p>Choose the matching fabric in <b>Choose Fabric</b> below.</p>");
              return;
            }
            setTimeout(paint, 0);
          });
          sg.appendChild(btn);
          return;
        }

        var b2 = blocked(k, have);
        if (!b2) return;
        sg.appendChild(ghost(k, b2));
      });
    } catch (e) {
    } finally {
      busy = false;
    }
  }

  /* ----------------------------------------------------------------------
     Fallback for the two flags the storefront module doesn't enhance
     (custom-printed-flags, wall-mounted-promotional-flags): those have no
     fabric axis, so their printing option is a plain <select>. The four
     methods are listed in it by relabelling the option TEXT only - every
     option value, the name and the id stay exactly as rendered - plus two
     listed-but-not-made entries whose selection is undone in the capture
     phase, before the theme's own change handler can see it.
     ---------------------------------------------------------------------- */
  function fallback() {
    try {
      var real = document.querySelector('select[data-variant-option="1"]');
      if (!real || real.getAttribute("data-bds-fb") === "1") return;
      var cell = real.closest(".config-cell");
      var h = cell ? cell.querySelector("h3") : null;
      if (!h || txt(h.textContent).toLowerCase().indexOf("printing option") < 0) return;
      real.setAttribute("data-bds-fb", "1");
      try { window.__BDS_FP_READY = Math.round(performance.now()); window.__BDS_FP_MODE = "select"; } catch (e) {}

      var have = {};
      [].forEach.call(real.options, function (o) {
        var k = methodOfPrefix(o.value);
        have[k] = true;
        o.setAttribute("data-bds-k", k);
        if (o.getAttribute("data-bds-orig") === null) o.setAttribute("data-bds-orig", o.textContent);
        o.textContent = M[k] || o.textContent;
      });

      var last = methodOfPrefix(real.value);

      ORDER.forEach(function (k) {
        if (have[k]) return;
        if (k === "TRIPLE") return;
        var b = blocked(k, have);
        if (!b) return;
        var o = document.createElement("option");
        o.value = "__bds_" + k;
        o.setAttribute("data-bds-m", k);
        o.textContent = M[k] + "   (" + (SUFFIX[b.tag] || "not available") + ")";
        real.appendChild(o);
      });

      document.addEventListener("change", function (ev) {
        try {
          if (ev.target !== real) return;
          if (real.getAttribute("data-bds-fb") !== "1") return;   /* undone */
          if (String(real.value).indexOf("__bds_") !== 0) {
            last = methodOfPrefix(real.value);
            return;
          }
          var k = String(real.value).slice(6);
          var back = [].slice.call(real.options).filter(function (o) {
            return o.getAttribute("data-bds-k") === last;
          })[0];
          if (back) real.value = back.value;
          ev.stopPropagation();
          ev.preventDefault();
          var b = blocked(k, have);
          if (b) popup(b.why, b.body, b.href, b.link);
        } catch (e) {}
      }, true);
    } catch (e) {}
  }

  /* Undo the plain-select path. The storefront module can be slow on a cold
     load; if its control turns up after we've already fallen back, put the
     select back exactly as the theme rendered it and use the control instead.
     Only ever restores - it never invents text. */
  function unfallback() {
    try {
      var real = document.querySelector('select[data-variant-option="1"]');
      if (!real || real.getAttribute("data-bds-fb") !== "1") return;
      real.setAttribute("data-bds-fb", "0");
      [].slice.call(real.options).forEach(function (o) {
        if (String(o.value).indexOf("__bds_") === 0) { o.parentNode.removeChild(o); return; }
        var orig = o.getAttribute("data-bds-orig");
        if (orig !== null) o.textContent = orig;
        o.removeAttribute("data-bds-k");
        o.removeAttribute("data-bds-orig");
      });
      window.__BDS_FP_MODE = "seg";
    } catch (e) {}
  }

  /* --------------------------------------------------------------- wiring
     The storefront module builds #bdsf-seg. On the two flags it doesn't
     enhance it never renders anything at all, so a page with no bdsf markup
     after a moment is a page it is not handling - take the plain-select path
     straight away rather than making the customer wait out the full timeout.
     ---------------------------------------------------------------------- */
  function start() {
    var tries = 0;

    /* Event-driven safety net: timers are throttled hard in a background tab,
       so don't let the plain-select path depend on a tick count alone. Once
       the page has finished loading, a page with no bdsf markup is a page the
       storefront module is not handling. */
    try {
      var onLoad = function () {
        if (window.__BDS_FP_READY) return;
        if (seg()) { paint(); observe(); return; }
        if (!document.querySelector('[class*="bdsf"]')) { fallback(); watchForSeg(); }
      };
      if (document.readyState === "complete") setTimeout(onLoad, 1200);
      else window.addEventListener("load", function () { setTimeout(onLoad, 1200); });
    } catch (e) {}

    (function wait() {
      if (seg()) { paint(); observe(); return; }
      tries++;
      if (tries >= 12 && !document.querySelector('[class*="bdsf"]')) { fallback(); watchForSeg(); return; }
      if (tries > 60) { fallback(); watchForSeg(); return; }   /* ~6s safety net */
      setTimeout(wait, 100);
    })();
  }

  /* If the storefront control turns up after the fallback, switch over. */
  function watchForSeg() {
    var n = 0;
    (function look() {
      if (seg()) { unfallback(); paint(); observe(); return; }
      if (++n > 120) return;                        /* give up after ~24s */
      setTimeout(look, 200);
    })();
  }

  function observe() {
    try {
      document.addEventListener("change", function (e) {
        var t = e.target;
        if (t && t.matches && t.matches('select[data-variant-option]')) setTimeout(paint, 0);
      }, false);
      document.addEventListener("click", function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (t.closest(".bdsf-opt[data-f]") || t.closest("#bdsf-seg button[data-p]")) setTimeout(paint, 30);
      }, false);
      if (window.MutationObserver) {
        var host = document.getElementById("bdsf-prhost") || document.body;
        var mo = new MutationObserver(function () {
          if (busy) return;
          var sg = seg();
          if (!sg) return;
          if (!sg.querySelector("button[data-bds-m]") || !sg.querySelector("button[data-bds-k]")) paint();
        });
        mo.observe(host, { childList: true, subtree: true });
      }
    } catch (e) {}
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();